import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ISecret, NotebookSecretFacade } from '@mode/notebooks/contract';
import { Observable, Subject, take, takeUntil } from 'rxjs';
import { trackByFactory } from '@mode/capra';
import { NotebookSecretModalService } from '../notebook-secret-modal/notebook-secret-modal.service';
import { NotebookSecretService } from '@mode/notebooks/domain';

@Component({
  selector: 'mode-notebook-secrets',
  templateUrl: './notebook-secrets.component.html',
  styleUrls: ['./notebook-secrets.component.scss'],
})
export class NotebookSecretsComponent implements OnInit {
  private destroyed$ = new Subject<void>();
  secrets$: Observable<ISecret[]>;
  isSecretsExist$: Observable<boolean>;
  secretKeys: string[] = [];
  trackByFn = trackByFactory<ISecret>(({ token }) => token);
  isDialogOpenObj: {
    [key: string]: boolean;
  } = {};

  constructor(
    private notebookSecretModalService: NotebookSecretModalService,
    private notebookSecretFacade: NotebookSecretFacade,
    private notebookSecretService: NotebookSecretService
  ) {
    this.secrets$ = this.notebookSecretFacade.secrets$;
    this.isSecretsExist$ = this.notebookSecretFacade.isSecretsExist$;
    this.notebookSecretService.secretKeys$.pipe(takeUntil(this.destroyed$)).subscribe((keys) => {
      this.secretKeys = keys;
    });
  }

  ngOnInit(): void {
    this.notebookSecretFacade.notebookToken$.pipe(take(1)).subscribe((token) => {
      if (token) {
        this.notebookSecretFacade.loadSecrets();
      }
    });
  }

  createSecret(): void {
    this.notebookSecretModalService.openCreateModal(this.secretKeys);
  }

  editSecret(secret: ISecret): void {
    this.notebookSecretModalService.openEditModal(secret, () => {
      this.clearDialogOpen(secret);
    });
  }

  deleteSecret(secret: ISecret): void {
    const modalConfig = {
      dialogTitle: 'Delete secret?',
      dialogText: `<p>Deleting <b class="bold-text unset-margin">${secret.key}</b> will also break any existing references to the secret in this Notebook, which may result in errors. This action can't be undone.</p>`,
      confirmText: 'Delete',
      cancelText: 'Cancel',
    };
    this.notebookSecretService.openDeleteSecretModal(secret, modalConfig, () => {
      this.clearDialogOpen(secret);
    });
  }

  handleDialogOpen({ token, active }: { token: string; active: boolean }): void {
    this.isDialogOpenObj = {
      ...this.isDialogOpenObj,
      [token]: active,
    };
  }

  clearDialogOpen(secret: ISecret): void {
    this.isDialogOpenObj = {};
    this.getActive(secret);
  }

  getActive(secret: ISecret): boolean {
    return !!this.isDialogOpenObj[secret.token];
  }
}
